const SITE_URL = 'https://mobidicsaju.com';
const SITE_NAME = '사주팔자AI';
const SITE_NAMES = {
  ko: '사주팔자AI',
  en: 'SajuPaljaAI',
  ja: '四柱八字AI',
  ru: 'Саджу AI',
  de: 'SajuPaljaAI',
};
const DEFAULT_LOCALE = 'ko';
const LOCALES = ['ko', 'en', 'ja', 'ru', 'de'];
const PREFIXED_LOCALES = LOCALES.filter(locale => locale !== DEFAULT_LOCALE);
const OG_LOCALES = {
  ko: 'ko_KR',
  en: 'en_US',
  ja: 'ja_JP',
  ru: 'ru_RU',
  de: 'de_DE',
};

const descriptions = {
  home: {
    ko: '전통 명리학과 AI를 결합한 사주, 타로, 궁합, 만세력, 점성술 서비스를 만나보세요.',
    en: 'Explore AI-powered Saju, tarot, compatibility, birth-chart, and astrology services rooted in traditional wisdom.',
    ja: '伝統命理学とAIを融合した四柱推命、タロット、相性、万歳暦、占星術サービスです。',
    ru: 'Сервисы Саджу, Таро, совместимости, календаря судьбы и астрологии на основе традиций и ИИ.',
    de: 'Entdecken Sie KI-gestützte Saju-, Tarot-, Partner-, Geburtschart- und Astrologieangebote mit traditioneller Grundlage.',
  },
  service: {
    ko: '사주팔자AI의 전문 분석 도구로 나의 운세와 삶의 흐름을 깊이 있게 살펴보세요.',
    en: 'Use SajuPaljaAI analysis tools to explore your fortune, character, and the patterns shaping your life.',
    ja: '四柱八字AIの専門分析ツールで、運勢や性格、人生の流れを詳しく読み解きます。',
    ru: 'Исследуйте судьбу, характер и жизненные циклы с помощью аналитических инструментов Саджу ИИ.',
    de: 'Erkunden Sie Schicksal, Charakter und Lebensphasen mit den Analysewerkzeugen von SajuPaljaAI.',
  },
  community: {
    ko: '사주팔자AI 이용자와 콘텐츠를 나누고 다양한 운세 이야기를 만나보세요.',
    en: 'Discover shared readings, stories, and conversations from the SajuPaljaAI community.',
    ja: '四柱八字AIコミュニティの鑑定、物語、さまざまな運勢の話題を楽しめます。',
    ru: 'Читайте материалы, истории и обсуждения сообщества Саджу ИИ.',
    de: 'Entdecken Sie Deutungen, Geschichten und Gespräche aus der SajuPaljaAI-Community.',
  },
  company: {
    ko: '사주팔자AI 서비스와 비즈니스, 개발자 연동 정보를 확인하세요.',
    en: 'Find service, business, and developer integration information for SajuPaljaAI.',
    ja: '四柱八字AIのサービス、ビジネス、開発者向け連携情報をご確認ください。',
    ru: 'Информация о сервисе, бизнесе и интеграции для разработчиков Саджу ИИ.',
    de: 'Informationen zu Service, Geschäft und Entwickler-Integrationen von SajuPaljaAI.',
  },
  legal: {
    ko: '사주팔자AI 서비스 이용에 적용되는 정책과 주요 안내를 확인하세요.',
    en: 'Review the policies and important information that apply to the SajuPaljaAI service.',
    ja: '四柱八字AIサービスに適用されるポリシーと重要事項をご確認ください。',
    ru: 'Ознакомьтесь с правилами и важной информацией сервиса Саджу ИИ.',
    de: 'Lesen Sie die Richtlinien und wichtigen Hinweise für den SajuPaljaAI-Dienst.',
  },
};

function localized(ko, en, ja, ru, de) {
  return { ko, en, ja, ru, de };
}

function route(path, titles, description, options = {}) {
  return {
    path,
    indexable: true,
    changefreq: options.changefreq || 'weekly',
    priority: options.priority || 0.7,
    title: titles,
    description,
  };
}

const SEO_ROUTES = [
  route('/', localized('사주팔자AI | AI 사주·타로·궁합', 'SajuPaljaAI | AI Saju, Tarot & Compatibility', '四柱八字AI | AI四柱推命・タロット・相性', 'Саджу ИИ | Судьба, Таро и совместимость', 'SajuPaljaAI | Saju, Tarot & Partnerschaft'), descriptions.home, { changefreq: 'daily', priority: 1 }),
  route('/fortune', localized('AI 사주풀이', 'AI Saju Reading', 'AI四柱推命鑑定', 'ИИ-анализ Саджу', 'KI-Saju-Deutung'), descriptions.service, { changefreq: 'daily', priority: 0.95 }),
  route('/tarot', localized('AI 타로 리딩', 'AI Tarot Reading', 'AIタロット占い', 'Расклад Таро с ИИ', 'KI-Tarotlegung'), descriptions.service, { changefreq: 'daily', priority: 0.9 }),
  route('/gunghap', localized('AI 궁합 분석', 'AI Compatibility Reading', 'AI相性診断', 'ИИ-анализ совместимости', 'KI-Partneranalyse'), descriptions.service, { priority: 0.9 }),
  route('/saju-pro', localized('만세력 프로', 'Professional Saju Birth Chart', 'プロ万歳暦', 'Профессиональная карта Саджу', 'Professioneller Saju-Geburtschart'), descriptions.service, { priority: 0.85 }),
  route('/manseryeok-ai', localized('AI 만세력 해석', 'AI Birth Chart Interpretation', 'AI万歳暦解釈', 'ИИ-толкование карты судьбы', 'KI-Geburtschart-Deutung'), descriptions.service, { priority: 0.82 }),
  route('/encyclopedia', localized('사주 명리 백과사전', 'Saju Encyclopedia', '四柱推命百科事典', 'Энциклопедия Саджу', 'Saju-Lexikon'), descriptions.service, { priority: 0.8 }),
  route('/board', localized('운세 이야기 게시판', 'Fortune Community Board', '運勢コミュニティ掲示板', 'Форум о судьбе', 'Schicksalsforum'), descriptions.community, { changefreq: 'daily', priority: 0.75 }),
  route('/gallery', localized('촉점 갤러리', 'Intuition Gallery', '直感ギャラリー', 'Галерея интуиции', 'Intuitionsgalerie'), descriptions.community, { changefreq: 'daily', priority: 0.75 }),
  route('/psychtest', localized('심리 테스트', 'Psychology Tests', '心理テスト', 'Психологические тесты', 'Psychologische Tests'), descriptions.service),
  route('/developer', localized('개발자 API', 'Developer API', '開発者API', 'API для разработчиков', 'Entwickler-API'), descriptions.company),
  route('/franchise', localized('사주팔자AI 가맹 안내', 'SajuPaljaAI Franchise', '四柱八字AI加盟案内', 'Франшиза Саджу ИИ', 'SajuPaljaAI-Partnerschaft'), descriptions.company),
  route('/saju-farm', localized('사주팜', 'Saju Farm', '四柱ファーム', 'Ферма Саджу', 'Saju-Farm'), descriptions.service),
  route('/ascii-tarot', localized('ASCII 타로', 'ASCII Tarot', 'ASCIIタロット', 'ASCII Таро', 'ASCII-Tarot'), descriptions.service),
  route('/ascii-tarot-gallery', localized('ASCII 타로 갤러리', 'ASCII Tarot Gallery', 'ASCIIタロットギャラリー', 'Галерея ASCII Таро', 'ASCII-Tarot-Galerie'), descriptions.community),
  route('/celebrities', localized('유명인 사주', 'Celebrity Saju', '有名人の四柱推命', 'Саджу знаменитостей', 'Prominenten-Saju'), descriptions.service, { changefreq: 'daily', priority: 0.8 }),
  route('/live', localized('운세 라이브 라운지', 'Fortune Live Lounge', '運勢ライブ・ラウンジ', 'Прямой эфир о судьбе', 'Live-Lounge für Schicksalsfragen'), descriptions.community, { changefreq: 'daily', priority: 0.8 }),
  route('/astrology', localized('AI 서양 점성술', 'AI Western Astrology', 'AI西洋占星術', 'Западная астрология с ИИ', 'Westliche Astrologie mit KI'), descriptions.service, { priority: 0.85 }),
  route('/saju-map', localized('전국 점집 지도', 'Korea Fortune Shop Map', '韓国占い店マップ', 'Карта гадальных салонов Кореи', 'Karte koreanischer Wahrsagestätten'), descriptions.service),
  route('/privacy', localized('개인정보처리방침', 'Privacy Policy', 'プライバシーポリシー', 'Политика конфиденциальности', 'Datenschutzerklärung'), descriptions.legal, { changefreq: 'yearly', priority: 0.3 }),
  route('/terms', localized('이용약관', 'Terms of Service', '利用規約', 'Условия использования', 'Nutzungsbedingungen'), descriptions.legal, { changefreq: 'yearly', priority: 0.3 }),
  route('/refund-policy', localized('환불 정책', 'Refund Policy', '返金ポリシー', 'Политика возврата', 'Rückerstattungsrichtlinie'), descriptions.legal, { changefreq: 'yearly', priority: 0.3 }),
];

const ROUTE_BY_PATH = new Map(SEO_ROUTES.map(entry => [entry.path, entry]));
const PREFIX_PATTERN = new RegExp(`^/(${PREFIXED_LOCALES.join('|')})(?=/|$)`);
const PRIVATE_PATTERNS = [
  /^\/(?:login|register|social-signup|kakao-channel|forgot-password|reset-password|login-success)(?:\/|$)/,
  /^\/(?:mypage|myeongri|notifications|charge|result|tarot-result|manseryeok-history)(?:\/|$)/,
  /^\/(?:admin|admin-dashboard|admin-erp)(?:\/|$)/,
  /^\/payment(?:-|\/)/,
  /^\/(?:board|gallery)\/(?:write|edit)(?:\/|$)/,
  /^\/live\/(?:chat|voice|radio)(?:\/|$)/,
  /^\/astrology\/r(?:\/|$)/,
  /^\/psychtest\/(?:[^/]+)(?:\/|$)/,
];

function normalizePath(pathname = '/') {
  const withoutPrefix = pathname.replace(PREFIX_PATTERN, '') || '/';
  if (withoutPrefix.length > 1) return withoutPrefix.replace(/\/+$/, '');
  return withoutPrefix;
}

function localizePath(path, locale = DEFAULT_LOCALE) {
  const logicalPath = normalizePath(path);
  if (locale === DEFAULT_LOCALE) return logicalPath;
  return logicalPath === '/' ? `/${locale}` : `/${locale}${logicalPath}`;
}

function classifySeoRoute(pathname) {
  const path = normalizePath(pathname);
  const entry = ROUTE_BY_PATH.get(path);
  if (entry) return { indexable: entry.indexable, path, entry };
  const isPrivate = PRIVATE_PATTERNS.some(pattern => pattern.test(path));
  return { indexable: false, private: isPrivate, path, entry: null };
}

function getLocalizedSeo(entry, locale = DEFAULT_LOCALE) {
  const safeLocale = LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  return {
    title: entry.title[safeLocale] || entry.title[DEFAULT_LOCALE],
    description: entry.description[safeLocale] || entry.description[DEFAULT_LOCALE],
  };
}

module.exports = {
  DEFAULT_LOCALE,
  LOCALES,
  OG_LOCALES,
  PREFIXED_LOCALES,
  SEO_ROUTES,
  SITE_NAME,
  SITE_NAMES,
  SITE_URL,
  classifySeoRoute,
  getLocalizedSeo,
  localizePath,
  normalizePath,
};